export class IpsPaymentLinkModal {
  saId: string = "";
  haName: string = "";
  productName: string = "";
  amountToBePaid: number = 0;
  totalAmount: number = 0;
  productAmount: number = 0;
  totalLicenses: number = 0;
  licenseDays: number = 0;
  isPaid: boolean;
  hospitalName: string;
  mobileNo: string;
  emailId: string;
  prodType: number;
  saName: string;
  saEmail: string;
}
